import { render, staticRenderFns } from "./scene.vue?vue&type=template&id=4e4cb8b9&scoped=true"
import script from "./scene.vue?vue&type=script&lang=js"
export * from "./scene.vue?vue&type=script&lang=js"
import style0 from "./scene.vue?vue&type=style&index=0&id=4e4cb8b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4cb8b9",
  null
  
)

export default component.exports